import AssessmentDataDB from 'src/fb/assessmentData-db';
import AssessmentsDB from 'src/fb/assessments-db';
import AssessmentTypesDB from 'src/fb/assessmentTypes-db';
import GenericDb from 'src/fb/generic-db';
import { auth as useAuthStore } from 'src/store/auth';
import { bindDataBaseStore, unbindDataBaseStore } from 'src/utils/FirestoreUtils';

export default {

  setAssessmentFieldOptions(assessmentFieldOptions) {
    this.assessmentFieldOptions = assessmentFieldOptions;
  }, // setAssessmentFieldOptions()

  loadAssessments() {
    const assessmentDb = new AssessmentsDB();

    const auth = useAuthStore();

    const ref = assessmentDb.getQuery([
      ['client', '==', auth.currentClient.id],
    ]);

    return bindDataBaseStore({ store: this, property: 'assessments' }, ref, []);
  }, // loadAssessments()

  async deleteAssessment(id) {
    const assessmentDb = new AssessmentsDB();

    try {
      await assessmentDb.delete(id);
      this.assessments = this.assessments.filter((assessment) => assessment.id !== id);
    } catch (error) {
      console.error(error);
    }
  }, // deleteAssessment()

  async loadAssessmentTypes() {
    if (this.assessmentTypes.length > 0) {
      return;
    }

    const assessmentTypesDb = new AssessmentTypesDB();
    const ref = assessmentTypesDb.getQuery();

    return bindDataBaseStore({ store: this, property: 'assessmentTypes' }, ref, []);
  }, // loadAssessmentTypes()

  async getAssessmentTypeFieldsByGroups(fieldGroups) {
    try {
      const assessmentTypeFieldsDb = new GenericDb('assessmentTypeFields');

      const query = await assessmentTypeFieldsDb.getQuery([
        ['assessmentTypeFieldGroup', 'in', fieldGroups],
      ]);

      await bindDataBaseStore({ store: this, property: 'assessmentTypeFields' }, query, []);
    } catch (error) {
      console.error(error);
    }
  }, // getAssessmentTypeFieldsByGroups()

  async getAssessmentTypeFields(assessmentTypeFieldGroupId) {
    try {
      const assessmentTypeFieldsDb = new GenericDb('assessmentTypeFields');

      const query = await assessmentTypeFieldsDb.getQuery([
        ['assessmentTypeFieldGroup', '==', assessmentTypeFieldGroupId],
      ]);

      await bindDataBaseStore({ store: this, property: 'assessmentTypeFields' }, query, []);
    } catch (error) {
      console.error(error);
    }
  }, // getAssessmentTypeFields()

  async getAssessmentTypeFieldGroups(assessmentTypeId) {
    const assessmentTypeFieldGroupsDb = new GenericDb('assessmentTypeFieldGroups');

    const query = await assessmentTypeFieldGroupsDb.getQuery([
      ['assessmentType', '==', assessmentTypeId],
    ]);

    await bindDataBaseStore({ store: this, property: 'assessmentTypeFieldGroups' }, query, []);
  }, // getAssessmentTypeFieldGroups()

  async getAssessmentFormFields(assessmentType) {
    await this.getAssessmentTypeFieldGroups(assessmentType);
    const groups = this.assessmentTypeFieldGroups.map((group) => group.id);

    await this.getAssessmentTypeFieldsByGroups(groups);
  }, // getAssessmentFormFields()

  async readDataFieldOptions({ field, clientId }) {
    const assessmentDataDb = new AssessmentDataDB();
    const assessmentData = await assessmentDataDb.readAll([
      ['client', '==', clientId],
    ]);

    return assessmentData.reduce((acc, data) => {
      if (!data.values[field]) {
        return acc;
      }
      if (!acc.includes(data.values[field])) {
        acc.push(data.values[field]);
      }
      return acc;
    }, [])
      .sort();
  }, // readDataFieldOptions()

  async getDataFieldOptions({ field, clientId }) {
    const assessmentFieldOptions = await this.readDataFieldOptions({ field, clientId });

    this.setAssessmentFieldOptions({ [field]: assessmentFieldOptions });
  }, // getDataFieldOptions()

  logout() {
    return Promise.all([
      this.unbindAssessments(),
      this.unbindAssessmentTypes(),
      this.unbindTypeFieldGroups(),
      this.unbindTypeFields(),
    ]);
  }, // logout()

  unbindAssessments() {
    return unbindDataBaseStore({ store: this, property: 'assessments' }, []);
  }, // unbindAssessments()

  unbindAssessmentTypes() {
    return unbindDataBaseStore({ store: this, property: 'assessmentTypes' }, []);
  }, // unbindAssessmentTypes()

  unbindTypeFieldGroups() {
    return unbindDataBaseStore({ store: this, property: 'assessmentTypeFieldGroups' }, []);
  }, // unbindTypeFieldGroups()

  unbindTypeFields() {
    return unbindDataBaseStore({ store: this, property: 'assessmentTypeFields' }, []);
  }, // unbindTypeFields()

};
